import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export const Footer = () => {
  return (
    <footer className="bg-[#1A1A1A] text-white/80" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-16">
          <div className="lg:col-span-1">
            <span className="font-heading text-3xl font-semibold text-white">
              2BW<span className="text-[#C5A065] ml-1">BAT</span>
            </span>
            <p className="mt-6 text-sm leading-relaxed text-white/60">
              L'excellence de la rénovation parisienne depuis 2000. 
              Artisan de confiance pour vos projets haut de gamme.
            </p>
            <div className="section-divider mt-6" />
          </div>

          <div>
            <h4 className="font-heading text-lg text-white mb-6">Navigation</h4>
            <nav className="flex flex-col gap-3">
              {[
                { href: "/", label: "Accueil" },
                { href: "/services", label: "Nos Services" },
                { href: "/a-propos", label: "A propos" },
                { href: "/blog", label: "Blog" },
                { href: "/contact", label: "Contact" },
              ].map((link) => (
                <Link key={link.href} to={link.href} className="text-sm text-white/50 hover:text-[#C5A065] transition-colors duration-300">
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-lg text-white mb-6">Services</h4>
            <nav className="flex flex-col gap-3">
              {["Maçonnerie", "Menuiserie", "Plomberie", "Electricité", "Peinture", "Isolation"].map((service) => (
                <span key={service} className="text-sm text-white/50">{service}</span>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="font-heading text-lg text-white mb-6">Contact</h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#C5A065] mt-0.5 shrink-0" />
                <span className="text-sm text-white/50">Paris 14e arrondissement<br />Ile-de-France</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#C5A065] shrink-0" />
                <a href="tel:+33666777517" className="text-sm text-white/50 hover:text-[#C5A065] transition-colors">06 66 77 75 17</a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#C5A065] shrink-0" />
                <a href="mailto:2bwbat@gmail.com" className="text-sm text-white/50 hover:text-[#C5A065] transition-colors">2bwbat@gmail.com</a>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-4 h-4 text-[#C5A065] mt-0.5 shrink-0" />
                <span className="text-sm text-white/50">Disponible 7j/7<br />pour vos projets</span>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">&copy; {new Date().getFullYear()} 2BW BAT. Tous droits réservés.</p>
          <p className="text-xs text-white/40">Artisan qualifié &mdash; Paris & Ile-de-France</p>
        </div>
      </div>
    </footer>
  );
};
